<sl-sidebar-layout>
  <router-outlet></router-outlet>
</sl-sidebar-layout>

<sl-error-modal
  *ngIf="showErrorModal"
  [errorMessage]="'errorModal.message' | transloco"
  (closeModal)="showErrorModal = false"
></sl-error-modal>
